// extracted by mini-css-extract-plugin
export var actionIcon = "_ph-0";